// extracted by mini-css-extract-plugin
export default {"attention":"styles_attention__0+NPq","messages":"styles_messages__ZI5zl","title":"styles_title__PYIc+","description":"styles_description__sOBEA"};